import React from "react";
import styles from "./activityhistory.module.scss";

type Props = { activity_history: Array<{ year?: string; title?: string }> };

export const ActivityHistory: React.FC<Props> = (props) => {
  const { activity_history } = props;

  return (
    <dl className={styles["c-activity-history"]}>
      {activity_history !== null && activity_history !== undefined
        ? activity_history.map((value, index) => {
            return (
              <React.Fragment key={index}>
                <dt className={styles["c-activity-history__year"]}>
                  <span>{value.year}</span>
                </dt>
                <dd className={styles["c-activity-history__text"]}>
                  {value.title}
                </dd>
              </React.Fragment>
            );
          })
        : null}
    </dl>
  );
};

export default ActivityHistory;
